import moment from 'moment';

export const getHoverText = (durationInSeconds) => {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor(durationInSeconds / 60) % 60;
  const seconds = Math.floor(durationInSeconds % 60);
  return `${hours.toString().length === 1 ? ('0' + hours).slice(-2) : hours}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
};

export const dayDate = (from, to, viewType) => {
  const dateArray = [];
  let currentDate = moment(from);
  const stopDate = moment(to);
  while (currentDate <= stopDate) {
    if (viewType === 'week' || viewType === 'month') {
      dateArray.push({
        date: currentDate.format('DD/M'),
        refDate: currentDate.format('YYYY-MM-DD'),
      });
    } else {
      dateArray.push({
        date: currentDate.format('DD'),
        refDate: currentDate.format('YYYY-MM-DD'),
      });
    }
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
};

export const yearDate = (from, to, formatDate) => {
  const defaultFormatDate = 'MM-YYYY'
  const dateArray = [];
  let currentDate = moment(from);
  const stopDate = moment(to);
  while (currentDate <= stopDate) {
    dateArray.push({
      date: currentDate.format('MM/YY'),
      refDate: formatDate ? currentDate.format(formatDate) : currentDate.format(defaultFormatDate),
    });
    currentDate = moment(currentDate).add(1, 'month');
  }
  return dateArray;
};

export const tenYearsDate = (from, to) => {
  const dateArray = [];
  let currentDate = moment(from);
  const stopDate = moment(to);
  while (currentDate <= stopDate) {
    dateArray.push({
      date: currentDate.format('YYYY'),
      refDate: currentDate.format('YYYY'),
    });
    currentDate = moment(currentDate).add(1, 'year');
  }
  return dateArray;
};

export const countDays = (viewType, data) => {
  let count = 0;
  if (viewType === 'year') {
    const noOfDates = data.map((d) => d.noOfDate);
    if (noOfDates.length > 0) {
      count = noOfDates.reduce((a, b) => a + b, 0);
    }
  } else {
    count = data.length;
  }
  // const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  // return Math.round(Math.abs((from - to) / oneDay));
  return count;
};
